// Merged Sana workspace — combines the former Sana analytics console and the
// AI Assistant into one tabbed hub.
import React from 'react';
import HubScreen from './HubScreen';
import SanaConsole from './SanaConsole';
import AIAssistant from './AIAssistant';

const TABS = [
  { id: 'analytics',   label: 'Analytics',    Component: SanaConsole },
  { id: 'aiassistant', label: 'AI Assistant', Component: AIAssistant },
];

export default function SanaWorkspace(props) {
  return <HubScreen tabs={TABS} passProps={props} title="Sana" />;
}
